(function () {
  angular.module("akitabox.ui.components.pinFieldFilters", [
    "akitabox.core",
    "akitabox.ui.components.rangeInput",
    "akitabox.ui.components.input",
  ]);
})();
